<template>
  <div>
      <div class="modal fade" id="register-popup">

<div class="modal-dialog modal-dialog-centered">

<div class="modal-content"><a href="#" class="modal-close" data-dismiss="modal" aria-label="Close"><em class="ti ti-close"></em></a>

<div class="ath-container m-0">

<div class="ath-body bg-theme tc-light"><h5 class="ath-heading title">Sign Up <small class="tc-default">Create New TokenWiz Account</small></h5>

<form action="#">

<div class="field-item">

<div class="field-wrap">
<input type="text" class="input-bordered" placeholder="Your Name">
</div>
</div>

<div class="field-item">

<div class="field-wrap">
<input type="text" class="input-bordered" placeholder="Your Email">
</div>
</div>

<div class="field-item">

<div class="field-wrap">
<input type="password" class="input-bordered" placeholder="Password">
</div>
</div>

<div class="field-item">

<div class="field-wrap">
<input type="password" class="input-bordered" placeholder="Repeat Password">
</div>
</div>

<div class="field-item">
<input class="input-checkbox" id="agree-term-2" type="checkbox">
<label for="agree-term-2">I agree to Icos <a href="#">Privacy Policy</a> &amp; <a href="#">Terms</a>.
</label>
</div><button class="btn btn-primary btn-block btn-md">Sign Up</button>
</form>

<div class="sap-text">

<span>Or Sign Up With
</span>
</div>
<ul class="row gutter-20px gutter-vr-20px">
<li class="col"><a href="#" class="btn btn-md btn-facebook btn-block"><em class="icon fab fa-facebook-f"></em>

<span>Facebook
</span></a></li>
<li class="col"><a href="#" class="btn btn-md btn-google btn-block"><em class="icon fab fa-google"></em>

<span>Google
</span></a></li>
</ul>

<div class="ath-note text-center"> Already have an account? <a href="#" data-toggle="modal" data-dismiss="modal" data-target="#login-popup"> <strong>Sign in here</strong></a>
</div>
</div>
</div>
</div>
</div>
</div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>